import { styled } from "@stitches/react";

const Wrapper = styled("div", {
  position: "absolute",
  zIndex: "1",
  top: "1rem",
  right: "1rem",
});

export { Wrapper };
